export default {
    namespaced: true,

    state: {
        alerts: []
    },

    mutations: {
        addAlert(state, data) {
            state.alerts.push({ ...data, id: Date.now() + Math.random() });

            setTimeout(() => {
                state.alerts.shift();
            }, 10000);
        },

        deleteAlert(state, data) {
            const index = state.alerts.findIndex(el => el.id === data.id);
            state.alerts.splice(index, 1);
        }
    },
};